<div
  class="flex align-center flex-between width-100 padding-05 rounded-right clickable"
  [ngClass]="{ active: isActive, inactive: !isActive }"
>
  <div class="flex align-center gap-05">
    <i [class]="icon"></i>
    <div>{{ title }}</div>
  </div>
  @if (unsavedContent) {
  <div
    class="flex align-center justify-center rounded-sm"
    style="background-color: var(--nt-yellow); color: black; padding: 0.25rem"
  >
    <i class="pi pi-save"></i>
  </div>
  }
</div>
